import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "giftsHead"
  }, [_c('div', {
    staticClass: "giftsHead-main"
  }, [_c('div', {
    staticClass: "btn-inventory",
    on: {
      "click": () => _vm.$router.push('/giftInventory')
    }
  }, [_vm._v("Inventory")]), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn-star"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/ton-stars.png`),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.starInfo.balance)))])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };